import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import ListItem from 'material-ui/List/ListItem';
import Avatar from 'material-ui/Avatar';
import ContentAdd from 'material-ui/svg-icons/content/add';

import MessagesUtils from '../infra/MessagesUtils';
import {connect} from 'react-redux';
import Analytics from 'infra/analytics/Analytics'

const ADD_ROOM = "AddRoom";
const ADD_MEMBER = "AddMember";
const styles = {
  checkbox: {
    marginTop: 16,
  },
};

class ChatRoomAddOperation extends Component {
  constructor(){
    super();
    this.state = {
      visible: false,
      recipients: [],
      loading: false
    };
  }

  componentWillMount(){
    this.setState({
      visible: (this.props.operation === ADD_ROOM ? this.props.addingRoom : false),
      loading: false
    });
  }

  componentWillUnmount(){
    this.setState({
      visible: false,
      loading: false,
      recipients: []
    });
  }

  componentWillReceiveProps(props){
    this.setState({
      visible: (this.props.operation === ADD_ROOM ? props.addingRoom : false)
    });
  }

  isLoading(){
    return !this.props.userMetadata
        || !this.props.teamMembers
  }

  handleOpen = () => {
    this.setState({visible: true});
  };

  handleClose = () => {
    if (this.props.operation === ADD_ROOM) {
      this.props.onComplete();
    }
    this.setState({visible: false, recipients: []});
  };

  handleSubmit = () => {
    if (this.state.recipients.length > 0){
      let selfAdded = false;
      const members = this.state.recipients.map(member => {
        if (member.userId === this.props.userMetadata.id){
          selfAdded = true;
        }
        return {
          userId: member.userId,
          displayName: member.displayName,
          access: member.access
        }
      });

      if (!selfAdded && this.props.operation === ADD_ROOM){
        //push self
        const selfMember = this.props.teamMembers.find((memberTeam) => memberTeam.userId === this.props.userMetadata.id)
        members.push({
          userId: this.props.userMetadata.id,
          displayName: this.props.userMetadata.displayName,
          access: selfMember.access,
        })
      }
      this.setState({loading: true})

      if (this.props.operation === ADD_ROOM) {
        MessagesUtils
        .createRoomWithMembers({title: ''}, {id: this.props.teamId}, members)
        .then((result) => {
          console.log('Created Room', result);
          this.props.onComplete(result.roomId);
          this.setState({visible: false, loading: false, recipients: []});
          Analytics.track(Analytics.ROOM_CREATED)
        })
        .catch((error) => {
          console.log('Error creating room - ', error);
          //TODO: create alert
          this.props.onComplete();
          this.setState({visible: false, loading: false, recipients: []});
        })
      } else if (this.props.operation === ADD_MEMBER) {
        MessagesUtils
        .addMembersToRoom({id: this.props.currentRoomId},
          {id: this.props.teamId},
          members)
        .then((result) => {
          console.log('Successfully added members to room', result);
          this.setState({visible: false, loading: false, recipients: []});
          Analytics.track(Analytics.ROOM_MEMBERS_ADDED)
        })
        .catch((err) => {
          console.log('Error creating room -', err);
          this.setState({visible: false, loading: false, recipients: []});
        })
      }
    }

  };

  isInputChecked = (event, isInputChecked, member) => {
    if (isInputChecked){
      this.addToRecipients(member);
    } else {
      //checkbox unclicked
      this.removeFromRecipients(member);
    }
  }

  addToRecipients = (member) => {
    const recipients = this.state.recipients;
    recipients.push(member);
    this.setState({recipients});
    return;
  }

  removeFromRecipients = (member) => {
    const recipients = this.state.recipients;
    const newRecipients = [];

    recipients.forEach(recipient => {
      if (member.userId !== recipient.userId){
        newRecipients.push(recipient);
      }
    })

    this.setState({recipients : newRecipients})
    return;
  }

  render() {

    const actions=[];
    const membersOptions = [];

    if (!this.state.loading){
      actions.push(
        <FlatButton
          label="Cancel"
          primary={false}
          onTouchTap={this.handleClose}
        />,
      );
      actions.push(
        <FlatButton
          label={this.props.operation === ADD_ROOM ? "Start" : "Add"}
          primary={true}
          keyboardFocused={true}
          onTouchTap={this.handleSubmit}
        />,
      );
    }

    if (!this.isLoading()){
      for (let id in this.props.teamMembers){
        if (this.props.teamMembers.hasOwnProperty(id)){
          const member = this.props.teamMembers[id];
          if (this.props.operation === ADD_ROOM || !this.props.currentMembers.hasOwnProperty(member.userId)) {
            membersOptions.push(
              <Checkbox
                key={member.userId}
                value={member.userId}
                label={member.displayName}
                style={styles.checkbox}
                onCheck={(event, isInputChecked) => this.isInputChecked(event, isInputChecked, member)}
              />
            );
          }
        }
      }
    }

    return (
      <div>
        {
          this.props.operation === ADD_MEMBER
          &&
          <ListItem
            onClick={() => this.setState({visible: true})}
            leftAvatar={
              <Avatar
                icon={<ContentAdd />}
              />
            }
          >
            Add New Member
          </ListItem>
        }
        <Dialog
          title={this.props.operation === ADD_MEMBER ? "Add New Members" : "Start New Message"}
          actions={actions}
          modal={false}
          open={this.state.visible}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
          contentStyle={{
            display:'flex',
            justifyContent: 'center'
          }}>
            {
              this.state.loading
              ?
              <CircularProgress
                  size={60} thickness={7} color='#527da3' style={{margin: '60px'}}/>
              :
              membersOptions
            }
        </Dialog>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userMetadata: state.firebase.user.metadata.value,
    teamMembers: state.firebase.team.members.value,
    teamId: state.firebase.team.metadata.value.id
  }
};

export default connect(mapStateToProps)(ChatRoomAddOperation);



// WEBPACK FOOTER //
// ./src/chat/ChatRoomAddOperation.js